import { createInvoiceReminder } from "../../models/invoice-reminder.model";

export const invoiceReminderState = {
  invoiceReminderList: null,
  selectedInvoiceReminder: createInvoiceReminder()
}